<div class="validation-message" [ngClass]="theme">
  <ng-container *ngTemplateOutlet="customTemplate || default"></ng-container>
</div>

<ng-template #default>
  <div class="d-flex flex-row align-items-center gap-10">
    <icon set="lucide" name="info" size="18" />
    <p class="label validation-message-text">
      <ng-content></ng-content>
    </p>
  </div>
</ng-template>
